import { ACTOR_KINDS, type ActorKind, AUDIT_ACTIONS, type AuditAction } from "@luckymenu/core";
import { createFileRoute } from "@tanstack/react-router";
import { AuditLogPage, type AuditSearch } from "../features/audit/audit-page";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DATE = /^\d{4}-\d{2}-\d{2}$/;

const pick = <T extends string>(value: unknown, test: (v: string) => boolean): T | undefined =>
	typeof value === "string" && test(value) ? (value as T) : undefined;

export const Route = createFileRoute("/audit-log")({
	validateSearch: (search: Record<string, unknown>): AuditSearch => {
		const found: AuditSearch = {
			restaurant: pick(search.restaurant, (v) => UUID.test(v)),
			person: pick(search.person, (v) => UUID.test(v)),
			kind: pick<ActorKind>(search.kind, (v) => (ACTOR_KINDS as readonly string[]).includes(v)),
			action: pick<AuditAction>(search.action, (v) =>
				(AUDIT_ACTIONS as readonly string[]).includes(v),
			),
			from: pick(search.from, (v) => DATE.test(v)),
			to: pick(search.to, (v) => DATE.test(v)),
		};
		return Object.fromEntries(
			Object.entries(found).filter(([, v]) => v !== undefined),
		) as AuditSearch;
	},
	component: Page,
});

function Page() {
	return <AuditLogPage search={Route.useSearch()} />;
}
